import { Component, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './confirm-dialog.component.html',
  styleUrl: './confirm-dialog.component.scss'
})
export class ConfirmDialogComponent {
  isVisible = false;
  title = 'Validation Warning';
  message = 'Process completed with warnings. Output can still be generated, but errors were identified in the assignment that require verification to ensure completeness.';
  confirmLabel = 'Generate Output';
  cancelLabel = 'GO TO ASSIGNMENT / REVIEW ERRORS';

  private resolvePromise: ((value: boolean | null) => void) | null = null;

  open(
    title?: string,
    message?: string,
    options?: { confirmLabel?: string; cancelLabel?: string }
  ): Promise<boolean | null> {
    this.title = title ?? this.title;
    this.message = message ?? this.message;
    this.confirmLabel = options?.confirmLabel ?? this.confirmLabel;
    this.cancelLabel = options?.cancelLabel ?? this.cancelLabel;
    this.isVisible = true;
    return new Promise<boolean | null>((resolve) => {
      this.resolvePromise = resolve;
    });
  }

  confirm(): void {
    this.isVisible = false;
    this.resolvePromise?.(true);
    this.resolvePromise = null;
  }

  cancel(): void {
    this.isVisible = false;
    this.resolvePromise?.(false);
    this.resolvePromise = null;
  }

  close(): void {
    this.isVisible = false;
    this.resolvePromise?.(null);
    this.resolvePromise = null;
  }

  @HostListener('document:keydown.escape')
  onEscapeKey(): void {
    if (this.isVisible) {
      this.close();
    }
  }
}
